import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const authAPI = {
  login: (email, password) => API.post("/auth/login", { email, password }),
  me: () => API.get("/auth/me"),
  logout: () => API.post("/auth/logout"),
};

export const leadsAPI = {
  list: (status, outcome) => {
    const params = {};
    if (status) params.status = status;
    if (outcome) params.outcome = outcome;
    return API.get("/leads", { params });
  },
  detail: (id) => API.get(`/leads/${id}/detail`),
  update: (id, data) => API.patch(`/leads/${id}`, data),
};

export const sellerSheetAPI = {
  update: (id, data) => API.patch(`/seller-sheet/${id}`, data),
};

export default API;
